import { render, staticRenderFns } from "./demandProtuctsCheck.vue?vue&type=template&id=46ed7156&scoped=true&"
import script from "./demandProtuctsCheck.vue?vue&type=script&lang=js&"
export * from "./demandProtuctsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed7156",
  null
  
)

export default component.exports